module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "my-3"
  }, [(_vm.paymentMethods) ? _c('ul', _vm._l((_vm.form.billing.payments), function(payment, index) {
    return _c('li', {
      staticClass: "d-flex mb-3"
    }, [_c('div', {
      staticClass: "d-flex"
    }, [_c('div', {
      staticClass: "flex-all mr-3"
    }, [_c('label', [_vm._v("Payment Method")]), _vm._v(" "), _c('vSelect', {
      attrs: {
        "options": _vm.paymentMethods,
        "searchable": false,
        "placeholder": "- Select type -",
        "label": "description"
      },
      model: {
        value: (payment.type),
        callback: function($$v) {
          _vm.$set(payment, "type", $$v)
        },
        expression: "payment.type"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "flex-all"
    }, [_c('label', [_vm._v("Amount")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (payment.value),
        expression: "payment.value"
      }],
      staticClass: "mb-0 text-right",
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (payment.value)
      },
      on: {
        "keyup": _vm.validatePayments,
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(payment, "value", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "mt-4 ml-3 pt-1"
    }, [(index > 0) ? _c('div', {
      on: {
        "click": function($event) {
          return _vm.deleteRow(index)
        }
      }
    }, [_c('i', {
      staticClass: "ico-delete color-1 larger pointer"
    })]) : _c('div', {
      on: {
        "click": function($event) {
          return _vm.addRow(payment.type)
        }
      }
    }, [_c('i', {
      staticClass: "ico-add add-circle"
    })])])])])
  }), 0) : _vm._e(), _vm._v(" "), (!_vm.validTotal || !_vm.validDeposit) ? _c('ul', [(!_vm.validTotal) ? _c('li', {
    staticClass: "d-flex error align-items-center mb-4"
  }, [_c('i', {
    staticClass: "ico-alert largest"
  }), _vm._v("\n            The payment amount exceeds the total price for this product.\n        ")]) : _vm._e(), _vm._v(" "), (!_vm.validDeposit) ? _c('li', {
    staticClass: "d-flex error align-items-center mb-4"
  }, [_c('i', {
    staticClass: "ico-alert largest"
  }), _vm._v("\n            Deposit must be charged - minimum value " + _vm._s(this.deposit.toFixed(2)) + "€.\n        ")]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-4432cbf4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4432cbf4"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservations/payment/PaymentMethods.vue
// module id = 1223
// module chunks = 0